import axios from "axios";
import {buildQuery} from "utils/queryUtils";

export const findBloodGroups = (headers, params) => {
    let query = buildQuery(params, ["code", "name"]);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/blood-groups${query}`, {
        headers
    })
}

export const countBloodGroups = (headers, params) => {
    let query = buildQuery(params);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/blood-groups/count${query}`, {
        headers
    })
}

export const findBloodGroupById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/blood-groups/${id}`, {
        headers
    })
}
